<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-dialog v-if="isView" v-model="isView" persistent width="800">
        <v-card class="mt-3 pa-1">
            <Title title="ライセンス編集">
                <v-spacer />
                <TitleButton
                    @click="onClickSave"
                    color="primary"
                    icon="mdi-floppy"
                    name="保存" />
                <TitleButton
                    color="primary"
                    icon="mdi-close-circle"
                    name="閉じる"
                    @click="isView = false" />
            </Title>
            <v-card-text class="pa-0">
                <v-container fluid>
                    <v-row >
                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                            <v-text-field
                                v-model="editItems.organization.name" 
                                dense
                                clearable 
                                label="組織名"
                                outlined
                                hide-details />
                        </v-col>
                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                            <v-text-field
                                v-model="editItems.organization.shortName" 
                                dense
                                clearable 
                                label="組織名(略称)"
                                outlined
                                hide-details />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" xs="12" sm="4" md="4" lg="3" xl="3" class="pt-0">
                            <v-card :max-width=180 outlined v-if="editImage != null">
                                <v-layout justify-center style="margin-top:10px">
                                    <v-img v-if="editImage.state == 2 || (editImage.url == '' && editImage.image == '')" src="@/assets/no_avater_image.png" :max-width=150 :max-height=150 contain alt="No image" />
                                    <v-img v-if="editImage.state != 2 && editImage.url != '' && editImage.image == ''" :src="editImage.url" :max-width=150 :max-height=150 contain />
                                    <v-img v-if="editImage.state != 2 && editImage.image != ''" :src="editImage.image" :max-width=150 :max-height=150 contain />
                                </v-layout>
                                <v-card-actions>
                                    <v-btn v-if="editImage.state == 1 || editImage.url != ''" icon color="primary" @click="onClickDeleteImage" ><v-icon large>mdi-delete</v-icon></v-btn>
                                    <v-spacer />
                                    <ImageImporter @onImportedImage="onImportedImage" />
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                            <v-text-field
                                v-model="editItems.code"
                                dense
                                label="ライセンスコード"
                                readonly
                                outlined
                                hide-details
                                append-icon="mdi-autorenew"
                                @click:append="onClickGenerateLicenseCode" />
                        </v-col>
                        <v-col v-if="targetLicense == null" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                            <v-text-field
                                v-model="editItems.password"
                                dense
                                label="パスワード"
                                readonly
                                outlined
                                hide-details
                                append-icon="mdi-autorenew"
                                @click:append="onClickGeneratePassword" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" >
                            <NumInput 
                                v-model="editItems.licenseInfo.licenseNum" 
                                outlined
                                hide-details 
                                label="ライセンス数"
                                type="text" 
                                align="align-left"
                                dense />
                        </v-col>
                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" >
                            <DatePicker 
                                label="ライセンス期限"
                                v-model="editItems.licenseInfo.toDate"
                                dense
                                icon="" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col v-if="targetLicense != null" cols="12" xs="12" sm="6" md="6" lg="6" xl="6" >
                            <v-checkbox 
                                v-model="editItems.deactivated"
                                hide-details
                                label="このライセンスを無効にする" />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
        <Confirm ref="confirm" />
    </v-dialog>
</template>

<script>
    Date.prototype.toFormatString = function (format) {
        const year = this.getFullYear()
        const month = this.getMonth() + 1
        const month2 = ("0" + month).slice(-2)
        const day2 = ("0" + this.getDate()).slice(-2)
        const hour2 = ("0" + this.getHours()).slice(-2)
        const minute2 = ("0" + this.getMinutes()).slice(-2)
        const second2 = ("0" + this.getSeconds()).slice(-2)

        const formattedValue = format.replace("yyyy", year).replace("MM", month2).replace("dd", day2).replace("HH", hour2).replace("mm", minute2).replace("ss", second2)

        return formattedValue
    }

    import fb from '@/firebase/firebase.js'
    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    import ImageImporter from '@/components/tools/ImageImporter';
    import Confirm from '@/components/tools/ConfirmDialog';
    import DatePicker from '@/components/tools/DatePicker';
    import NumInput from '@/components/tools/SoftwareNumKeyboard'
    import jsSHA from "jssha"

    export default {
        components: {
            Title,
            TitleButton,
            Confirm,
            DatePicker,
            NumInput,
            ImageImporter
        },
        props: {
            licenses: {
                type: Array,
                default: []
            }
        },
        data: function () {
            return {
                isView: false,
                editItems: {
                    organization: {
                        name: "",
                        shortName: "",
                        avaterURL: ""
                    },
                    code: "",
                    password: "",
                    deactivated: false,
                    licenseInfo: {
                        licenseNum: 0,
                        toDate: ""
                    }
                },
                editImage: {
                    url: "",
                    image: "",
                    capturedDate: "",
                    state: 0    // 0:未変更,1:変更,2:削除
                },
                targetLicense: null
            }
        },
        methods: {
            /**
             * アバターの画像がインポートされた時
             */
            onImportedImage: function (image) {
                this.editImage.image = image
                this.editImage.state = 1
                this.editImage.capturedDate = this.df_currentDateTime()
            },
            /**
             * アバターの画像に対して削除が行われた時
             */
            onClickDeleteImage: function () {
                this.editImage.url = ""
                this.editImage.image = ""
                this.editImage.state = 2                    
            },
            /**
             * ライセンスコードの作成ボタン押下時
             */
            onClickGenerateLicenseCode: function () {
                this.editItems.code = this.generateRandomString(16)
            },
            /**
             * パスワードの作成ボタン押下時
             */
            onClickGeneratePassword: function () {
                this.editItems.password = this.generateRandomString(8)
            },
            /**
             * 保存ボタン押下時
             */
            onClickSave: function () {
                const self = this
                console.log(this.editItems)
                this.$refs.confirm.show({
                    title: "ライセンスの登録",
                    message: "ライセンスを登録しますか？",
                    buttonYes: "登録する",
                    buttonNo: "いいえ",
                    width: 400,
                    listenerYes: function () {
                        self.updateLicense()
                        return true
                    },
                })
            },
            /**
             * ライセンスの登録処理
             */
            updateLicense: function () {

                const self = this
                const currentDate = new Date()

                // 更新データ作成
                var isNewLicense = false

                if (this.targetLicense == null) {
                    isNewLicense = true
                    this.targetLicense = {
                        version: "1.0.0",
                        code: this.editItems.code,
                        password: this.generateHashedString(this.editItems.password),
                        organization: {
                            name: "",
                            shortName: "",
                            avaterURL: "",
                        },
                        deactivated: false,
                        addins: [],
                        licenseInfo: {
                            date: currentDate.toFormatString("yyyy-MM-dd"),
                            activated: false,
                            activatedUserUID: "",
                            activatedDateTime: "",
                            licenseNum: 0,
                            toDate: ""
                        },
                        registeredDateTime: currentDate.toFormatString("yyyy-MM-dd HH:mm:ss")
                    }
                }

                this.targetLicense.organization.name = this.editItems.organization.name
                this.targetLicense.organization.shortName = this.editItems.organization.shortName
                this.targetLicense.deactivated = this.editItems.deactivated
                this.targetLicense.licenseInfo.licenseNum = this.editItems.licenseInfo.licenseNum * 1
                this.targetLicense.licenseInfo.toDate = this.editItems.licenseInfo.toDate

                const updater = function () {
                    db.collection("licenses").doc(self.targetLicense.code).set(self.targetLicense).then(function(){
                        if (isNewLicense) {
                            self.licenses.push(self.targetLicense)
                        }
                        self.$store.commit("notification", {message:"ライセンスを登録しました。", isError: false})
                        self.isView = false
                    }).catch (function (error) {
                        console.log("license update failed!!", error)
                        self.$store.commit("notification", {message:"ライセンスの登録に失敗しました。", isError: true})
                    })
                }

                // アバターから処理
                // 処理終了後、ライセンスデータの更新
                const uploadUrl = "images/licenses/" + this.targetLicense.code + "/image"
                var storage = fb.storage().ref()
                var outputRef = storage.child(uploadUrl)

                console.log("editImage", self.editImage)
                switch (self.editImage.state) {
                    case 1: // 変更
                        // ===============================
                        // 画像のアップロード
                        const startIndex = self.editImage.image.indexOf(",") + 1
                        outputRef.putString(self.editImage.image.substring(startIndex), 'base64').then(function(snapShot){
                            snapShot.ref.getDownloadURL().then (function(url){
                                self.targetLicense.organization.avaterURL = url
                                // =======================================
                                // 画像の処理が終了で、ライセンス情報更新
                                updater()
                            })
                        })
                        break;
                    case 2:
                        if (self.targetLicense.organization.avaterURL != "") {
                            console.log("delete image start")
                            outputRef.delete().then(function (){
                                console.log("delete image completed")
                                self.targetLicense.organization.avaterURL = ""
                                updater()
                            })
                        }
                        break;
                    case 0:
                        updater()
                        break;
                }
            },
            /**
             * 指定された文字列をハッシュ化して返す
             */
            generateHashedString: function (text) {
                const sha256 = new jsSHA("SHA-256", "TEXT")
                sha256.update(text)
                return sha256.getHash("HEX")
                // return hash.generate(text, {algorithm:"sha256", saltLength: 10, iterations:10})
            },
            /**
             * 指定された桁数のランダムな文字列を作成して返す
             */
            generateRandomString: function (length) {
                const characters = "0123456789abcdefghjkmnprstuwxyzAEFHKLMNR"
                var code = ""
                for (var i=0; i<length; i++) {
                    const index = Math.floor(Math.random() * (characters.length + 1))
                    code += (characters.substr(index, 1))
                }
                return code
            },
            /**
             * このダイアログを表示
             */
            show: function (license) {
                if (license == null) {
                    this.targetLicense = null
                    this.editItems = {
                        organization: {
                            name: "",
                            shortName: "",
                            avaterURL: ""
                        },
                        code: "",
                        password: "",
                        deactivated: false,
                        licenseInfo: {
                            licenseNum: 0,
                            toDate: ""
                        }
                    }
                    this.editImage = {
                        url: "",
                        image: "",
                        capturedDate: "",
                        state: 0    // 0:未変更,1:変更,2:削除
                    }
                } else {
                    this.targetLicense = license
                    this.editItems = {
                        organization: {
                            name: license.organization.name,
                            shortName: license.organization.shortName,
                            avaterURL: license.organization.avaterURL
                        },
                        code: license.code,
                        password: "",
                        deactivated: license.deactivated,
                        licenseInfo: {
                            licenseNum: license.licenseInfo.licenseNum,
                            toDate: license.licenseInfo.toDate
                        }
                    }                    
                    this.editImage = {
                        url: this.targetLicense.organization.avaterURL,
                        image: "",
                        capturedDate: "",
                        state: 0    // 0:未変更,1:変更,2:削除
                    }
                }
                this.isView = true
            }
        }
    }
</script>
